import { AppSidebar } from "@/components/heka/navigation/app-sidebar";
import { Navbar } from "@/components/heka/navigation/navbar";
import { SidebarProvider } from "@/components/ui/sidebar";

const HomeLayout = (props: { children: JSX.Element }) => {
  return (
    <SidebarProvider>
      <AppSidebar />
      <Navbar children={props.children} />
    </SidebarProvider>
  );
};

export default HomeLayout;
